import { Button, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import FieldTitle from "./FieldTitle";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import { useRecordContext } from "react-admin";
import CustomProductCheckboxGroup from "../../unit/forms/CustomProductCheckboxGroup";
import CustomProductIntTextField from "../../unit/forms/CustomProductIntTextField";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function Collateral({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "collateral";
  const sectionTitle =
    "Collateral - Set requirements on the collateral used to secure the loan";
  const sectionSubtitle = "";

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.collateral;
  const productType = record?.data?.basic?.type;
  const subType = record?.data?.basic?.subType;
  const division = record?.data?.basic?.division;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;
  const [selected, setSelected] = React.useState(
    data?.propertyLocationStatesData
  );
  const [selectedProperty, setSelectedProperty] = React.useState(
    data?.selectedProperty || []
  );
  const propertyPurposeList = data?.propertyPurposeList || [];
  const propertyPurposeOptions = propertyPurposeList.map((item: any) => ({
    id: item.id,
    label: item.sPropertyPurpose,
  }));
  const [showDetail, setShowDetail] = React.useState(false);
  const [showSubmit, setShowSubmit] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
    setValue,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({});
    }
  }, [data, reset]);
  React.useEffect(() => {
    // console.log("Description isDirty changed====>:", isDirty);
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    formData.propertyLocationStates = selected.join("|");
    formData.propertyPurpose = selectedProperty.join("|");
    // console.log("Form data:", formData);
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  function ucfirst(subType: any) {
    return subType.charAt(0).toUpperCase() + subType.slice(1);
  }

  const handleChangeState = (selectedItemStr: any) => {
    setSelected(selectedItemStr.split(",").map((item: string) => item.trim()));
    setShowSubmit(true);
  };
  const handleChangePropertyState = (selectedItemStr: any) => {
    setSelectedProperty(
      selectedItemStr.split(",").map((item: string) => item.trim())
    );
    setShowSubmit(true);
  };
  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box sx={{ padding: "10px" }}>
        {(ucfirst(subType) == "Mortgage" ||
          ucfirst(subType) == "Car" ||
          ucfirst(subType) == "Purchasecar" ||
          ucfirst(subType) == "Refinancecar") && (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  Property Registration Location Permitted
                </Typography>
                <Controller
                  name="propertyLocationStates"
                  control={control}
                  render={({ field }) => (
                    <CustomProductCheckboxGroup
                      {...field}
                      selected={selected}
                      handleChange={handleChangeState}
                      optionlist={[
                        { id: "AK", label: "Alaska" },
                        { id: "AL", label: "Alabama" },
                        { id: "AR", label: "Arkansas" },
                        { id: "AZ", label: "Arizona" },
                        { id: "CA", label: "California" },
                        { id: "CO", label: "Colorado" },
                        { id: "CT", label: "Connecticut" },
                        { id: "DC", label: "District Of Columbia" },
                        { id: "DE", label: "Delaware" },
                        { id: "FL", label: "Florida" },
                        { id: "GA", label: "Georgia" },
                        { id: "HI", label: "Hawaii" },
                        { id: "IA", label: "Iowa" },
                        { id: "ID", label: "Idaho" },
                        { id: "IL", label: "Illinois" },
                        { id: "IN", label: "Indiana" },
                        { id: "KS", label: "Kansas" },
                        { id: "KY", label: "Kentucky" },
                        { id: "LA", label: "Louisiana" },
                        { id: "MA", label: "Massachusetts" },
                        { id: "MD", label: "Maryland" },
                        { id: "ME", label: "Maine" },
                        { id: "MI", label: "Michigan" },
                        { id: "MN", label: "Minnesota" },
                        { id: "MO", label: "Missouri" },
                        { id: "MS", label: "Mississippi" },
                        { id: "MT", label: "Montana" },
                        { id: "NC", label: "North Carolina" },
                        { id: "ND", label: "North Dakota" },
                        { id: "NE", label: "Nebraska" },
                        { id: "NH", label: "New Hampshire" },
                        { id: "NJ", label: "New Jersey" },
                        { id: "NM", label: "New Mexico" },
                        { id: "NV", label: "Nevada" },
                        { id: "NY", label: "New York" },
                        { id: "OH", label: "Ohio" },
                        { id: "OK", label: "Oklahoma" },
                        { id: "OR", label: "Oregon" },
                        { id: "PA", label: "Pennsylvania" },
                        { id: "RI", label: "Rhode Island" },
                        { id: "SC", label: "South Carolina" },
                        { id: "SD", label: "South Dakota" },
                        { id: "TN", label: "Tennessee" },
                        { id: "TX", label: "Texas" },
                        { id: "UT", label: "Utah" },
                        { id: "VA", label: "Virginia" },
                        { id: "VT", label: "Vermont" },
                        { id: "WA", label: "Washington" },
                        { id: "WI", label: "Wisconsin" },
                        { id: "WV", label: "West Virginia" },
                        { id: "WY", label: "Wyoming" },
                      ]}
                    />
                  )}
                />
              </Grid>
            </Grid>
            {ucfirst(subType) == "Mortgage" && (
              <>
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <FieldTitle title="Minimum Down Payment to Value Ratio (%)" />
                  </Grid>
                  <Grid item xs={1}>
                    <Controller
                      name="iMinDownPayment"
                      control={control}
                      defaultValue={data?.iMinDownPayment || ""}
                      render={({ field }) => (
                        <CustomProductIntTextField
                          {...field}
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={8}></Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FieldTitle title="Property Purpose Permitted" />
                    <Controller
                      name="propertyPurpose"
                      control={control}
                      render={({ field }) => (
                        <CustomProductCheckboxGroup
                          {...field}
                          selected={selectedProperty}
                          handleChange={handleChangePropertyState}
                          optionlist={propertyPurposeOptions}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </>
            )}

            <CustomProductActionBottom>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveClick}
                disabled={!showSubmit}
                sx={{ width: "120px", mt: 1 }}
              >
                Save
              </Button>
            </CustomProductActionBottom>
          </>
        )}
      </Box>
    </SectionStyled>
  );
}
